import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager } from "../../../utils";

export const signOut = createAsyncThunk('signOut', async ({ navigate }) => {
    try {
        const res = await axios({
            method: "POST",
            url: process.env.REACT_APP_API_URL + 'sign_out',
            headers: {
                "Content-Type": "application/json",
                "Authorization": SessionManager.getCookie("user_token")
            }
        })
        return res
    } catch (error) {
        return error.response
    }
})